<template>
  <SupporterButton
    title="Become a supporter!"
    body="Help fund the growth of Ball.app"
    @click="openModal({name: RouteName.supporter})"
  />
</template>

<script lang="ts" setup>
import SupporterButton from "@/components/SupporterButton.vue";
import { RouteName } from "@/lib/router/routes";
import useModalStore from "@/stores/useModalStore";

const {
  openModal,
} = useModalStore();
</script>
